module.exports = __webpack_public_path__ + "static/media/Recommended Pricing Guide.e987c626.pdf";